var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var PropTypes = require('prop-types');
var FBLoginButton = require('./fbLoginButton.jsx');

var FBLoginButtonWrapper = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        return (
            <div className="fb-login-button-wrapper">
                <FBLoginButton {...this.props} />
            </div>
        );
    }
});

FBLoginButtonWrapper.propTypes = {
    authFacebook: PropTypes.func.isRequired
};

module.exports = FBLoginButtonWrapper;



// WEBPACK FOOTER //
// ./src/common/routes/components/fbLoginButtonWrapper.jsx